import axios from 'axios';
import AppModel from 'Models/AppModel';
import { cleanProduct } from 'Root/helpers/product';

export default {
  state() {
    return {
      activeGame: null,
      user: {},
      offersPage: {
        pagination: {
          page: 1,
          limit: 10,
          offset: 0,
          sort_column: 'price_per_step',
          sort_direction: 'asc',
          onlineNow: false,
        },
        filters: {},
        offers: [],
        total: 0,
      },
      product: {},
    };
  },

  getters: {
    gameId(state) {
      if (!state.activeGame) {
        return null;
      }

      return state.user.seller_currency_settings.find((e) => e.related_title === state.activeGame)?.id;
    },

    hasActiveGames(state) {
      return !!state.user.seller_currency_settings?.length;
    },
  },

  mutations: {
    setUser(state, user) {
      state.user = user;

      if (user?.approved_at) {
        const [day, month, year] = new Date(user.approved_at).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }).split(' ');

        state.user.approved_at = `${day} ${month}, ${year}`;
      }
    },

    setProduct(state, product) {
      state.product = product ? cleanProduct(product) : null;
    },

    setOffers(state, offers) {
      if (!Array.isArray(offers)) {
        state.offersPage.offers = [...offers.result];
        state.offersPage.total = offers.total;
      } else {
        state.offersPage.offers = [...offers];
        state.offersPage.total = offers.length;
      }
    },

    setFilters(state, filters) {
      state.offersPage.filters = filters;
    },

    setOffersPage(state, page) {
      state.offersPage.pagination.page = page;
    },

    setActiveGame(state, game) {
      state.activeGame = game;
    },

    changePagination(state, pagination) {
      state.offersPage.pagination = { ...pagination };
    },
  },

  actions: {
    async fetchUser({ commit }, userId) {
      const { data: user } = await axios.get(`${AppModel.API_URI}/currency_marketplace/seller/${userId}`);

      commit('setUser', user);
    },

    async fetchProduct({ commit }, gameId) {
      const { data } = await axios
        .get(`${AppModel.API_URI}/currency_marketplace/products/list`, { params: { with_id: gameId } });

      if (data?.result?.length) {
        commit('setProduct', data.result.pop());
      } else {
        commit('setProduct', null);
      }
    },

    async fetchOffers({ commit, state }, { params, gameId }) {
      const paramsWithUser = { ...params, with_user_id: state.user.id };

      const { data } = await axios
        .get(`${AppModel.API_URI}/currency_marketplace/offers/${gameId}/list`, {
          params: paramsWithUser,
        });

      commit('setOffers', data);
    },
  },

  namespaced: true,
};
